<template>
  <v-container>
    <v-card>
      <v-card-title> Seguimiento a Recursos Financieros </v-card-title>
      <v-card-text>
        <div class="h6">
          Apropiación presupuestal para la implementación del Acuerdo Final de
          Paz
        </div>
        <div>
          Conozca los recursos financieros apropiados para la implementación de
          los Acuerdos de Paz, por cada una de las fuentes de financiación y
          puntos.
        </div>
        <v-card>
          <v-card-title>
            Por Punto del Acuerdo » 

            <v-layout style="align-items: center;">
              <v-menu
                :open-on-hover="false"
                :close-on-content-click="true"
                :offset-x="false"
                :offset-y="true"
              >
                <template v-slot:activator="{ on }">
                  {{ nombrepunto }}
                  <v-btn text icon v-on="on">
                    <v-icon>icon-list</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in gplurianualgrouppunto.filter( record => {return record.vigencia == parseInt($route.params.vigencia);})"
                    :key="index"
                    @click="seleccionardata(item.idpunto, item.vigencia, item.nombre)"
                  >
                    <v-list-item-title>{{
                      item.nombre
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-layout>

            <hr />
          </v-card-title>
          <v-card-text>
            <div v-if="recursopunto.length > 0">
              <barra :concepto="recursopunto" />
              <div class="font-weight-bold">
                Detalle desagregado por fuente de financiación
              </div>
            </div>

            <v-data-table
              :headers="HeaderFuentes"
              :items="recursofuente"
              class="elevation-1"
              :no-data-text="gnodata"
              :items-per-page="10"
            >
              <template v-slot:[`item.png`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.png) }}
              </template>
              <template v-slot:[`item.sgp`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.sgp) }}
              </template>
              <template v-slot:[`item.sgr`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.sgr) }}
              </template>
              <template v-slot:[`item.cooperacion`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.cooperacion) }}
              </template>
              <template v-slot:[`item.privados`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.privados) }}
              </template>
              <template v-slot:[`item.entidadest`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.entidadest) }}
              </template>
              <template v-slot:[`item.total`]="{ item }">
                {{ Intl.NumberFormat("es-CO", { maximumFractionDigits: 0 }).format(item.total) }}
              </template>
              <template v-slot:footer>
                <div id="div1" style="width: 100%; align: right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <download-excel
                        id="div2"
                        style="width: 100%; text-align: right"
                        v-show="recursofuente.length > 0"
                        class="btn btn-default"
                        :data="recursofuente"
                        :exportFields="exportable"
                        name="RecursosFinancieros.xls"
                        type="xls"
                        worksheet="Información"
                      >
                        <v-icon
                          color="secondary"
                          v-on="on"
                          large
                          elevation="2"
                          >mdi-file-download-outline</v-icon
                        >
                      </download-excel>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </div>
              </template>


            </v-data-table>
            <hr>
              <div class="Subtitle-2 text-center font-weight-bold">Fecha de corte: 31 diciembre de {{getvigencia}} -  <a href="http://www.portalparalapaz.gov.co/publicaciones/990/informes-de-seguimiento/genPagdoc131=2" target="_blank">Fuente: Informe del PPI Paz  {{getvigencia}} -  millones de pesos de {{getvigencia}}.</a>  </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import barra from "../../components/chart/barra.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "recursosapropiacionpresp",
  data() {
    return {
      getidpunto: 0,
      getvigencia: 0,
      recursopunto: [],
      nombrepunto: "",
      recursofuente: [],
      colores: [],
      recursosplurianualcorte: '',
      HeaderFuentes: [
        { text: "Pilar PMI", value: "nombrepilar", align: "left", width: 400 },
        { text: "PGN", value: "png", align: "right" },
        { text: "SGP", value: "sgp", align: "right" },
        { text: "SGR", value: "sgr", align: "right" },
        { text: "Cooperación", value: "cooperacion", align: "right" },
        {
          text: "Recursos propios (Ent. territoriales)",
          value: "entidadest",
          align: "right",
          width: 170
        },
        { text: "Privados", value: "privados", align: "right" },
        { text: "Total", value: "total", align: "right" },
      ],
      exportable: {
        "Pilar PMI": "nombrepilar",
        PGN:  { 
            field: "png", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              },
        SGP:  { 
            field: "sgp", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              },
        SGR:   { 
            field: "sgr", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              },
        Cooperación:   { 
            field: "cooperacion", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              }, 
        "Recursos propios":   { 
            field: "entidadest", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              }, 
        Privados:   { 
            field: "privados", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              }, 
        Total:   { 
            field: "total", 
            callback: (value) => { return ` ${Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(value * 1000000)}`; },
              },  
      },
    };
  },
  methods: {
    ...mapActions([
      "get_rplurianualpunto",
      "get_plurianualfuentes",
      "get_recursocifras",
      "get_rplurianualgrouppunto",
      "get_plurianualfuentes",
      "get_plurianualpuntopilar"
    ]),    
      seleccionardata(Setidpunto, Setvigencia, Setnombre) {

        this.getidpunto = Setidpunto
        this.getvigencia = parseInt(Setvigencia)
        this.nombrepunto = Setnombre

        if (this.gpluripuntopilar.length > 0){
          this.recursopunto = this.gpluripuntopilar.filter((element) => {
            if (element.idpunto == parseInt(this.getidpunto) && element.vigencia == this.getvigencia)
            return element;
          }); 
        }

        if (this.gplurifuente.length > 0)
        this.recursofuente = this.gplurifuente.filter((element) => {
          if (element.idpunto == parseInt(this.getidpunto) && element.vigencia == this.getvigencia)
          return element;
        });    
      }
  },
  components: {
    barra,
  },
  created() {
    this.get_rplurianualpunto();
    this.get_plurianualfuentes();
    this.get_recursocifras();
    this.seleccionardata(this.$route.params.idpunto, this.$route.params.vigencia, '');
    this.get_rplurianualgrouppunto();
    this.get_plurianualfuentes();
    this.get_plurianualpuntopilar();
  },
  computed: {
    ...mapGetters(["gplurianualpunto", "gplurianualfuente", "grcifras", "gplurianualgrouppunto", "gplurifuente", "gpluripuntopilar" ]),    
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
  },
  watch: {
    grcifras: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.recursosplurianualcorte = this.grcifras.filter( record => {return record.tipo == "RecursoPlurianualCorte";})[0];
      }
    },
    gplurifuente: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (parseInt(this.getidpunto) > 0)
        {
          this.recursofuente = this.gplurifuente.filter((element) => {
            if (element.idpunto == parseInt(this.getidpunto) && element.vigencia == this.getvigencia)
            return element;
          });   
        }      
      }
    },
    gpluripuntopilar: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (parseInt(this.getidpunto) > 0) {        
          this.recursopunto = this.gpluripuntopilar.filter((element) => {
            if (element.idpunto == parseInt(this.getidpunto) && element.vigencia == this.getvigencia)
            return element;
          }); 
        this.nombrepunto = this.gplurianualgrouppunto.filter( record => {return record.vigencia == parseInt(this.$route.params.vigencia) && record.idpunto == parseInt(this.getidpunto)})[0].nombre;
        }     
      }
    }    
  }
};
</script>